import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid2';

/**
 * Skeletons (Design 3.0, D4) — Laden ohne Aufploppen.
 * Die Formen ahmen das spätere Layout grob nach, damit nichts springt.
 */

// Detailseite: Kopfzeile + Kachel-Fläche (Lead/Kontakt/Unternehmen/Projekt)
export function DetailSkeleton() {
  return (
    <Box>
      <Skeleton variant="text" width={280} height={44} sx={{ mb: 0.5 }} />
      <Skeleton variant="text" width={180} height={22} sx={{ mb: 2.5 }} />
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Skeleton variant="rounded" height={320} sx={{ borderRadius: '12px' }} />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <Skeleton variant="rounded" height={120} sx={{ borderRadius: '12px', mb: 2 }} />
          <Skeleton variant="rounded" height={184} sx={{ borderRadius: '12px' }} />
        </Grid>
      </Grid>
    </Box>
  );
}

// Startseiten-Cockpit: KPI-Reihe + zwei Kachelzeilen
export function DashboardSkeleton() {
  return (
    <Box>
      <Skeleton variant="text" width={300} height={48} sx={{ mb: 2 }} />
      <Grid container spacing={1.5} sx={{ mb: 1.5 }}>
        {[0, 1, 2, 3].map((i) => (
          <Grid key={i} size={{ xs: 6, md: 3 }}>
            <Skeleton variant="rounded" height={148} sx={{ borderRadius: '14px' }} />
          </Grid>
        ))}
      </Grid>
      <Grid container spacing={1.5}>
        {[0, 1, 2].map((i) => (
          <Grid key={i} size={{ xs: 12, md: 4 }}>
            <Skeleton variant="rounded" height={260} sx={{ borderRadius: '14px' }} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
